import axios from "./axios";
import { ModelResponseDto } from "../components/common/ObjectTypes";

export async function getModels(query?: {
  model_id?: number;
  model_display_name?: string;
  classification_model?: string;
  detection_model?: string;
  skip?: number;
  take?: number;
  sort_by?: string;
  sort_direction?: string;
  all_models?: boolean;
}): Promise<{ models: ModelResponseDto[]; count: number }> {
  try {
    // If all_models is true, remove skip and take parameters
    const params = { ...query };
    if (params && params.all_models) {
      delete params.skip;
      delete params.take;
    }

    const resp = await axios.get("/models", {
      params: params,
    });
    return resp.data;
  } catch (error) {
    const err = error as any; // Type assertion for better error handling
    console.error("Error fetching models:", err);
    if (err.response) {
      console.error("Response status:", err.response.status);
      console.error("Response data:", err.response.data);
    }
    throw err;
  }
}

export async function getModel(modelId: string): Promise<ModelResponseDto> {
  try {
    const resp = await axios.get(`/models/${modelId}`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}

// export async function createModel(
//   data: ModelCreateUpdateDto,
// ): Promise<ModelResponseDto> {
//   try {
//     const resp = await axios.post("/models", data);
//     return resp.data;
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// }

// export async function updateModel(
//   data: ModelCreateUpdateDto,
// ): Promise<ModelResponseDto> {
//   try {
//     const resp = await axios.put(`/models/${data.id}`, data);
//     return resp.data;
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// }

export async function deleteModel(modelId: string): Promise<any> {
  try {
    const resp = await axios.delete(`/models/${modelId}`);
    return resp.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
